import { useParams, Navigate } from "react-router-dom";
import { PageHero, SectionHeading } from "@/components/site/Sections";
import { CtaButton } from "@/components/site/CtaButton";
import { Reveal } from "@/components/site/Reveal";
import { VerticalTimeline } from "@/components/site/ProcessFlow";
import { SERVICES, ADDONS } from "@/data/content";
import { Check, AlertTriangle } from "lucide-react";

export default function ServicePage() {
  const { slug } = useParams();
  const svc = SERVICES[slug];
  if (!svc) return <Navigate to="/" replace />;

  return (
    <div>
      <PageHero eyebrow={svc.eyebrow} title={svc.headline} subtitle={svc.intro} image={svc.image}>
        <CtaButton to={svc.cta.to} size="lg">{svc.cta.label}</CtaButton>
      </PageHero>

      {svc.timeline && (
        <section className="border-b border-slate-200 py-20 lg:py-24">
          <div className="mx-auto max-w-7xl px-4 lg:px-8">
            <SectionHeading center eyebrow="The Path" title="From Winning Bid to Stabilization" />
            <div className="mt-12">
              <VerticalTimeline steps={svc.timeline} />
            </div>
          </div>
        </section>
      )}

      <section className="py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-4 lg:px-8">
          <SectionHeading eyebrow={svc.title} title="What's Coordinated" />
          <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {svc.sections.map((sec, i) => (
              <Reveal key={sec.title} delay={i * 80}>
                <div className="h-full rounded-xl border border-slate-200 bg-white p-7">
                  <h3 className="text-base font-semibold text-gold">{sec.title}</h3>
                  <ul className="mt-4 space-y-2.5">
                    {sec.items.map((it) => (
                      <li key={it} className="flex items-start gap-2 text-sm text-slate-600">
                        <Check className="mt-0.5 h-4 w-4 shrink-0 text-gold/70" /> {it}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            ))}
          </div>

          {svc.note && (
            <div className="mt-10 flex items-start gap-3 rounded-xl border border-slate-200 bg-white p-5">
              <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-gold" />
              <p className="text-sm leading-relaxed text-slate-500">{svc.note}</p>
            </div>
          )}
        </div>
      </section>

      {/* Add-ons */}
      <section className="border-y border-slate-200 bg-[#F5F3EC] py-20 lg:py-24">
        <div className="mx-auto max-w-7xl px-4 lg:px-8">
          <SectionHeading center eyebrow="Optional Add-Ons" title="Extend Any Engagement" />
          <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {ADDONS.map((a, i) => (
              <Reveal key={a.title} delay={i * 50}>
                <div className="h-full rounded-xl border border-slate-200 bg-white p-6">
                  <h4 className="text-sm font-semibold text-[#0B132B]">{a.title}</h4>
                  <p className="mt-2 text-sm text-slate-500">{a.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="mt-12 text-center">
            <CtaButton to="/submit-property" size="lg">Submit a Property</CtaButton>
          </div>
        </div>
      </section>
    </div>
  );
}
